import mqtt from 'mqtt';

class MqttClient {
  options = {
    clean: true, // true: 清除会话, false: 保留会话
    connectTimeout: 4000, // 超时时间
    reconnectPeriod: 10000, // 重连时间间隔
    clientId: `mqttjs_${Math.random().toString(16).substr(2, 8)}`,
    username: `${this.getAccountFromLocalStorage()}-${localStorage.getItem('appId')}`, // 当前租户编码
    password: `${localStorage.getItem('token')}`, // token
  };

  connectUrl = '';

  client = null;

  topic = '';

  constructor() {
    if (typeof MqttClient.instance === 'object') {
      return MqttClient.instance;
    }
    MqttClient.instance = this;
    this.init();
  }

  /**
   * 初始化mqtt
   * @return
   */
  init() {
    //    if (window.location.host.includes('dev')) {
    //      this.connectUrl = 'wss://mqtt-dev.linggekj.com:8084/mqtt';
    //    } else if (process.env.NODE_ENV === 'development') {
    //      this.connectUrl = 'wss://mqtt-dev.linggekj.com:8084/mqtt';
    //    } else if (window.location.host.includes('sit') || window.location.host.includes('test')) {
    //      this.connectUrl = 'wss://mqtt-sit.linggekj.com:8084/mqtt';
    //    } else if (process.env.NODE_ENV === 'production') {
    //      this.connectUrl = 'wss://mqtt.linggekj.com:8084/mqtt';
    //    }
    //    this.client = mqtt.connect(this.connectUrl, this.options);
    //    this.client.on('reconnect', (error) => {
    //      console.log('正在重连，请检查mq链接 始终无法连接，请联系客服:', error, this.connectUrl);
    //      setTimeout(() => {
    //        this.client.reconnect(this.options);
    //      }, 100000);
    //    });
    //    this.client.on('connect', () => {
    //      console.log('连接成功....', this.connectUrl);
    //    });
    //    this.client.on('error', (error) => {
    //      console.log('连接失败:', error);
    //    });
  }

  /**
   * 注册一个主题
   * @return
   *
   */
  subscribeTopic(topic) {
    return;
    const self = this;
    self.client.subscribe(topic, (err) => {
      if (!err) {
        console.log('subscribe success!');
      } else {
        // 打印错误
        console.log('err', err);
      }
    });
  }

  /**
   * 接受一个mqtt对应的主题订阅
   *
   */
  receiveMessageWithTopic(callback) {
    const self = this;
    self.client.on('message', (topic, message) => {
      console.log('消息', message);
      callback(topic, message);
    });
  }

  /**
   * 向一个主题提送消息
   *
   */
  sendMessageWithTopic(topic, message) {
    this.client.publish(topic, JSON.stringify(message));
  }

  /**
   * 获取name
   */
  // eslint-disable-next-line class-methods-use-this
  getAccountFromLocalStorage() {
    const userInfoString = localStorage.getItem('user_info');

    if (!userInfoString) {
      return '';
    }

    try {
      const userInfo = JSON.parse(userInfoString);

      // eslint-disable-next-line no-prototype-builtins
      if (userInfo.hasOwnProperty('domainAccount')) {
        return userInfo.domainAccount;
      }
      // eslint-disable-next-line no-prototype-builtins
      if (userInfo.hasOwnProperty('passportAccount')) {
        return userInfo.passportAccount;
      }

      return '';
    } catch (error) {
      console.error('Error parsing JSON from user_info:', error);
      return '';
    }
  }
}

export default MqttClient;
